const probeMoveTcpc = (args,probeFeatureArgs,progArgs,machine) => {
  const {
    point,
    direction,
    "start-distance": startDistance,
    "end-distance": endDistance,
    mode
  } = args;

  const {
    "probe-diameter": probeDiameter
  } = progArgs;

  const [ space, orderStr ] = mode.split("-");

  if(orderStr.indexOf("x") === -1 ||
     orderStr.indexOf("y") === -1 ||
     orderStr.indexOf("z") === -1) {
    throw new Error("Must specify x, y and z in order string.");
  }

  const order = orderStr.split(",");

  const x = point.x;
  const y = point.y;
  const z = point.z;

  const dx = direction.x;
  const dy = direction.y;
  const dz = direction.z;

  const startX = x+dx*(startDistance+probeDiameter*.5);
  const startY = y+dy*(startDistance+probeDiameter*.5);
  const startZ = z+dz*(startDistance+probeDiameter*.5);

  const moveX = -dx*(startDistance-endDistance);
  const moveY = -dy*(startDistance-endDistance);
  const moveZ = -dz*(startDistance-endDistance);

  const lines = [];

  if(space === "global") {
    order.forEach((o) => {
      const i = o.indexOf("x") !== -1 ? 1 : 0;
      const j = o.indexOf("y") !== -1 ? 1 : 0;
      const k = o.indexOf("z") !== -1 ? 1 : 0;
      const sum = i+j+k;
      if(sum !== o.length) {
        throw new Error("Unexpected character in order string.");
      }

      if(sum === 0) {
        throw new Error("Must specify x, y, and/or z between each comma in order string.");
      }
      lines.push(`G6.2 X${startX.toFixed(5)} Y${startY.toFixed(5)} Z${startZ.toFixed(5)} I${i} J${j} K${k} P1 F120`);
    });
  } else {
    throw new Error("Only global space is implemented.");
  }

  lines.push("M428");

  // Using a basic feed rate move, but will do probing routine on the real machine
  lines.push(`G1 F10 X${(startX+moveX).toFixed(5)} Y${(startY+moveY).toFixed(5)} Z${(startZ+moveZ).toFixed(5)}`);
  lines.push(`G1 F10 X${(startX).toFixed(5)} Y${(startY).toFixed(5)} Z${(startZ).toFixed(5)}`);

  lines.push("M429");

  return lines;
}

const moveTcpc = (args,probeFeatureArgs,progArgs,machine) => {
  const {
    point,
    mode
  } = args;

  const [ space, orderStr ] = mode.split("-");

  if(orderStr.indexOf("x") === -1 ||
     orderStr.indexOf("y") === -1 ||
     orderStr.indexOf("z") === -1) {
    throw new Error("Must specify x, y and z in order string.");
  }

  const order = orderStr.split(",");

  const x = point.x;
  const y = point.y;
  const z = point.z;

  const lines = [];

  if(space === "global") {
    order.forEach((o) => {
      const i = o.indexOf("x") !== -1 ? 1 : 0;
      const j = o.indexOf("y") !== -1 ? 1 : 0;
      const k = o.indexOf("z") !== -1 ? 1 : 0;
      const sum = i+j+k;
      if(sum !== o.length) {
        throw new Error("Unexpected character in order string.");
      }

      if(sum === 0) {
        throw new Error("Must specify x, y, and/or z between each comma in order string.");
      }
      lines.push(`G6.2 X${x.toFixed(5)} Y${y.toFixed(5)} Z${z.toFixed(5)} I${i} J${j} K${k} P1 F120`);
    });
  } else {
    throw new Error("Only global space is implemented.");
  }

  return lines;
}

const safetyMove = (args, progArgs, machine) => {
  const safeJoints = machine.safeJoints;
  return [ `G53 G0 Z${safeJoints[2].toFixed(5)}`,
           `G53 G0 X${safeJoints[0].toFixed(5)} Y${safeJoints[1].toFixed(5)}` ];
};

const align = (args, progArgs, machine) => {
  const rotaryLabels = [ "A", "B", "C" ]

  const line = ["G0"]
  rotaryLabels.forEach((label) => {
    if(typeof(args[label]) !== "undefined") {
      line.push(`${label}${args[label].toFixed(5)}`)
    }
  });

  return [ line.join(" ") ];
};

const probeFeatureTcpc = (args, progArgs, machine) => {
  const cmds = args.cmds;
  const feature = args.feature;

  if(typeof(cmds) === "undefined") {
    throw new Error("Missing cmds property");
  }
  if(typeof(feature) === "undefined") {
    throw new Error("Missing feature property");
  }

  const lines = [];

  for(let i = 0; i < cmds.length; i++) {
    const c = cmds[i];

    const tcpcCmd = c.cmd;
    const tcpcArgs = c.args;

    const f = TCPC_MOVES[tcpcCmd];

    if(f) {
      lines.push(...f(tcpcArgs, args, progArgs, machine));
    } else {
      throw new Error(`Unknown command ${tcpcCmd}.`);
    }
  }
  return lines;
};

const noop = (args, progArgs, machine) => {
  return [ "" ];
};

const COMMANDS = {
  "safety-move": safetyMove,
  "align": align,
  "probe-feature-tcpc": probeFeatureTcpc,
  "project-points-onto-plane": noop,
  "intersect-lines": noop,
  "set-g5x-offset": noop 
};

const TCPC_MOVES = {
  "probe": probeMoveTcpc,
  "move": moveTcpc
};

export class ProbingInterpreter {
  constructor(program, machine) {
    this.gcodeLines = this.processProgram(program, machine);
  }

  processProgram(program, machine) {
    const operations = program.cmds;
    const progArgs = program.args;

    const lines = [];

    const initLines = [ "%" ];

    const safeJoints = machine.safeJoints;

    initLines.push("G90");
    initLines.push("M6 T14");
    initLines.push("G43 H14");
    initLines.push("G53 G0 Z0");
    initLines.push(`G0 X${safeJoints[0].toFixed(5)} Y${safeJoints[1].toFixed(5)}`)

    lines.push(initLines);

    for(let i = 0; i < operations.length; i++) {
      const cmd = operations[i];

      const cmdProcessor = COMMANDS[cmd.cmd];
      if(cmdProcessor) {
        try {
          const cmdLines = [ `(Probing operation ${i+1}: ${cmd.cmd})` ];
          cmdLines.push(...cmdProcessor(cmd.args, progArgs, machine));
          lines.push(cmdLines);
        } catch(e) {
          throw new Error(`Error processing cmd index ${i}: ${e.stack}`);
        }
      } else {
        throw new Error(`Error processing cmd index ${i}: invalid command ${cmd.cmd}`);
      }
    }

    const wrapUpLines = [ '%' ];

    lines.push(wrapUpLines);
    return lines;
  }
};

export default ProbingInterpreter;
